import { type Ref, onMounted, onUnmounted, ref } from 'vue'

export function useOnScreen(elementRef: Ref<Element | undefined>, threshold: number = 0.1) {
    const isVisible = ref(false)
    let observer: IntersectionObserver | null = null

    onMounted(() => {
        if (!elementRef.value) {
            return
        }

        observer = new IntersectionObserver(
            ([entry]) => {
                isVisible.value = !!entry?.isIntersecting
            },
            {
                threshold,
            },
        )

        observer.observe(elementRef.value)
    })

    onUnmounted(() => {
        if (observer) {
            observer.disconnect()
        }
    })

    return { isVisible }
}
